import React, { useEffect, useState } from 'react';
import type { Msg } from '../../utils/historyMessage';

// F3e C5: a mensagem de histórico (uma por vez: erro, início dos dados ou carregando), CENTRALIZADA, com 8 px de
// margem de cada lado, no máximo 2 linhas, e o "tentar de novo" junto, centralizado. O layout vai em estilo inline
// (não depende do Tailwind: o harness mede as caixas por geometria); as cores e a fonte seguem os avisos de antes.
// `inline` = dentro da coluna da MÁQUINA DO TEMPO, logo abaixo da pílula (solta na mesma altura ficaria atrás dela).
// "carregando" espera 150 ms (sem piscar quando o bloco chega logo).
export const HISTORY_MESSAGE_DELAY_MS = 150;
export const HISTORY_MESSAGE_TOP = 'calc(8rem + 3.75rem)';
const SIDE_MARGIN = 8;

export const HistoryMessage = React.memo<{ msg: Msg | null; onRetry: () => void; inline?: boolean }>(({ msg, onRetry, inline }) => {
  const delayed = msg?.tipo === 'carregando';
  const [shown, setShown] = useState(!delayed);
  useEffect(() => {
    if (!delayed) { setShown(true); return; }
    setShown(false);
    const id = setTimeout(() => setShown(true), HISTORY_MESSAGE_DELAY_MS);
    return () => clearTimeout(id);
  }, [delayed, msg?.texto]);
  if (!msg || !shown) return null;
  const stop = (e: React.SyntheticEvent) => e.stopPropagation();
  const erro = msg.tipo === 'erro';
  const wrap: React.CSSProperties = inline
    ? { marginTop: 16, display: 'flex', justifyContent: 'center', padding: `0 ${SIDE_MARGIN}px`, maxWidth: '100vw', boxSizing: 'border-box', pointerEvents: 'none' }
    : { position: 'absolute', left: SIDE_MARGIN, right: SIDE_MARGIN, top: HISTORY_MESSAGE_TOP, zIndex: 99, display: 'flex', justifyContent: 'center', pointerEvents: 'none' };
  return (
    <div role={erro ? 'alert' : 'status'} aria-live="polite" data-testid="history-message" data-kind={msg.tipo} style={wrap} className="animate-in fade-in duration-200">
      <div style={{ maxWidth: '100%', display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', columnGap: 8, rowGap: 4 }}>
        <span
          data-testid="history-message-text"
          style={{ maxWidth: '100%', textAlign: 'center', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', fontSize: 10, lineHeight: '14px', letterSpacing: '0.06em' }}
          className={`font-mono ${erro ? 'text-[#ffb020]/90' : 'text-[#00d9ff]/70'}`}
        >
          {msg.texto}
        </span>
        {msg.tentar && (
          <button
            type="button"
            data-testid="history-message-retry"
            style={{ pointerEvents: 'auto', fontSize: 10, lineHeight: '14px', padding: '2px 8px', whiteSpace: 'nowrap' }}
            className="font-mono rounded border border-[#ffb020]/50 text-[#ffb020] hover:bg-[#ffb020]/10"
            onPointerDown={stop} onPointerUp={stop} onTouchStart={stop} onTouchEnd={stop}
            onClick={(e) => { e.stopPropagation(); onRetry(); }}
          >
            tentar de novo
          </button>
        )}
      </div>
    </div>
  );
});
